import {Fragment,View} from "vritra";
import Post from "./Post/Post";


export default function Blog(props){
    const blog=Fragment(props);

    blog.innateHTML=`
    `;
    statics.posts.forEach(post=>{
        Post({...post,parent:blog});
    });
    
    return blog;
}

const statics={
    posts:new Array(3).fill().map((_,i)=>({
        title:"post "+(i+1),
        body:`This is the body of post ${i+1}`,
    })),
}
